import { Box, Typography, TextField, Button, Link, CircularProgress, Snackbar} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { LoadingButton } from '@mui/lab';
import { styled, useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useState } from 'react';
import { sendValidacao } from '../../../services/checkout-service/sendValidacao';

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  fontSize: '0.9rem',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const validationSchema = Yup.object().shape({
  codigo: Yup.string()
    .length(4, 'O código deve ter exatamente 4 caracteres')
    .required('Campo obrigatório'),
});

export default function CodigoNoEmail({ navigate, emailMask, numeroSerie }) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [reenviando, setReenviando] = useState(false);
  const [erroCodigo, setErroCodigo] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const enviarCodigoValidacao = async (codigo) => {
    try {
      setLoading(true);
      setErroCodigo('');
      const resp = await sendValidacao(codigo, numeroSerie);
      if (resp.status === 200) {
        localStorage.setItem(
          'tecnozap_user_session',
          JSON.stringify({
            ...(resp.data || {}),
            numSerie: numeroSerie,
            trustedVci: true,
            validatedAt: new Date().toISOString(),
          })
        );
        navigate(3);
      } else {
        setErroCodigo("Erro ao validar código");
      }

    } catch (error) {
      console.error('Error sending code: ', error);
      if (error.response && error.response.status === 406) {
        setErroCodigo("Código inválido");
      } else {
        setErroCodigo("Erro ao validar código");
      }
    } finally {
      setLoading(false);
    }
  };

  const reenviarCodigo = async () => {
    try {
      setReenviando(true);
      await sendValidacao('', numeroSerie);
      setOpenSnackbar(true);
    } catch (e) {
      console.error(e);
    } finally {
      setReenviando(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" component="h3" sx={{ color: theme.palette.error.main, mb: 3 }}>
        Você está offline
      </Typography>

      <Typography variant="body1" color="textPrimary" marginBottom={1}>
        Um código para validação do número de série foi enviado ao seu email:
      </Typography>

      <Typography
        variant="body1"
        sx={{
          backgroundColor: '#f5f5f5',
          padding: '16px',
          borderRadius: '4px',
          border: '1px solid #ddd',
          marginBottom: '20px',
        }}
      >
        {emailMask}
      </Typography>

      <Typography variant="body1" color="textPrimary" marginBottom={2}>
        Informe o código validador para iniciar seu atendimento.
      </Typography>

      <Formik
        initialValues={{ codigo: '' }}
        validationSchema={validationSchema}
        onSubmit={(v) => enviarCodigoValidacao(v.codigo)}
      >
        {({ isValid, dirty, setFieldValue }) => (
          <Form style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
            <Typography
              variant="body1"
              component="label"
              htmlFor="codigo"
              sx={{
                display: 'block',
                textAlign: 'center',
                mb: 1,
                fontWeight: 'bold',
              }}
            >
              Código validador
            </Typography>
            <Field
              as={TextField}
              id="codigo"
              name="codigo"
              placeholder="Ex: 0000"
              variant="outlined"
              size="medium"
              fullWidth
              sx={{ mb: 0 }}
              inputProps={{ maxLength: 4, style: { textAlign: 'center' } }}
              onChange={(e) => {
                setFieldValue('codigo', e.target.value);
                setErroCodigo('');
              }}
            />
            <ErrorMessage name="codigo" component="div" style={{ color: 'red', marginBottom: '8px' }} />

            {
               erroCodigo !== ""  && <Typography  style={{ color: 'red', marginBottom: '8px' }} > {

                erroCodigo} </Typography>
            }


            <StyledLink onClick={reenviarCodigo} sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {reenviando ? (
                <>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Reenviando...
                </>
              ) : (
                'Reenviar o email com o código validador.'
              )}
            </StyledLink>

            <Box sx={{ display: 'flex', flex: 1, alignItems: 'end', mt: 3 }}>
              <LoadingButton loading={loading} type="submit" variant="contained" fullWidth disabled={!isValid || !dirty}>
                Enviar
              </LoadingButton>
            </Box>
          </Form>
        )}
      </Formik>
      <Snackbar
      key={openSnackbar ? 'open' : 'closed'}
      open={openSnackbar}
      autoHideDuration={4000}
      onClose={() => setOpenSnackbar(false)}
      message="Email reenviado com sucesso!"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ '& .MuiSnackbarContent-root': { backgroundColor: '#4caf50', color: 'white', fontSize: '1rem' } }}
   />
    </Box>
  );
}
